import { useLingui } from "@lingui/react/macro";

import { navigator } from "~/service/dom.ts";
import { useUser } from "~/ui/provider/Auth.tsx";
import { useNotification } from "~/ui/provider/Notification.tsx";

export const useSharedProfile = (close: () => void) => {
  const push = useNotification();
  const { t } = useLingui();
  const { myInfo } = useUser();

  const myEmail = myInfo?.email ?? "";
  const shareUrl = `https://yogi-poke.vercel.app/me/${myEmail}`;

  const handleShare = () => {
    close();
    void navigator?.share({
      title: t`(@${myEmail}) - 요기콕콕! 프로필 공유`,
      url: shareUrl,
    });
  };

  const handleCopy = () => {
    void navigator?.clipboard.writeText(shareUrl).then(() => {
      push({ content: t`클립보드에 복사되었습니다.` });
    });
  };

  return {
    handleCopy,
    handleShare,
    myEmail,
    shareUrl,
  };
};
